import { gql } from '@apollo/client';

export const GET_PENDING_PICKING_PACKAGE_LIST = gql`
  query GetPendingPickingPackageList {
    getPendingPickingPackageList {
      locationNo
      trackingNumber
      nextAction
      pickingActionDetail
      locationOrderNo
      locationId
      buildTime
      updatedAt
      pickingStatus
    }
  }
`;

export interface WarehouseLocationPackageListItem {
  locationNo: string;
  trackingNumber: string;
  nextAction?: string;
  pickingActionDetail?: string;
  locationOrderNo: number;
  locationId?: number;
  buildTime?: number;
  updatedAt?: number;
  pickingStatus: number;
}

export interface GetPendingPickingPackageListResponse {
  getPendingPickingPackageList: WarehouseLocationPackageListItem[];
}
